<template>
	<div>
		<x-modal
			:wWidth="1080"
			v-if="visible == true"
			@cancel="close"
			@close="close"
			@ok="submit"
			:draggable="true"
			:resizable="true"
			:loading="loading"
			:okDisabled="disabled"
			okText="Send a Signing Request"
		>
			<div slot="title" :class="`d-flex justify-content-between align-items-center`">Send Digital Signing Request</div>

			<div class="container">
				<el-form :model="form" label-width="140px">

                    <el-form-item class="mt-4" label="Document">
						<el-select
							class="w-100"
							v-model="form.docForSigning"
							placeholder="Select Document for Signing"
							value-key="id"
							clearable
						>
							<el-option
								v-for="docs in docsForSigning"
								:key="`${docs.id}-${Number(docs.is_app_document)}`"
								:label="docs.filename"
								:value="docs"
							></el-option>
						</el-select>
					</el-form-item>

                    <email-sending-options></email-sending-options>

					<email-recipients
						v-if="!_.isEmpty(form.docForSigning) && (emailBuilder.sendEmail || emailBuilder.sendSms)"
						:recipientAllowCreate="false"
						:autoSelectRecipients="true"
                        autoSelectType="all"
                        :populateRecipients="populateRecipients"
						:hideCC="!emailBuilder.sendEmail ? true : false"
                        :hideBCC="!emailBuilder.sendEmail ? true : false"
						:loadRecipients="form.selectedEmails"
						:key="form.stillToSign.join(',')">
                        <el-tag v-if="!populateRecipients" type="success">All recipients have signed the document</el-tag>
					</email-recipients>

					<email-task v-model="emailBuilder.task"></email-task>

					<el-divider v-if="!_.isEmpty(emailBuilder.recipients) && (emailBuilder.sendEmail || emailBuilder.sendSms)"></el-divider>

					<email-markup-multi
						class="mb-3"
						v-if="!_.isEmpty(emailBuilder.recipients) && (emailBuilder.sendEmail || emailBuilder.sendSms)"
						action="digital-signature"
						:data="{
							docForSigning: form.docForSigning,
						}"
					></email-markup-multi>
				</el-form>
			</div>
		</x-modal>
	</div>
</template>

<script>
	import { mapGetters } from "vuex"
    import EmailSendingOptions from "@ambition/components/messages/EmailSendingOptions.vue"
	import EmailRecipients from "@ambition/components/messages/EmailRecipients"
	import EmailAttachments from "@ambition/components/messages/EmailAttachments"
	import EmailMarkupMulti from "@ambition/components/messages/EmailMarkupMulti"
	import EmailTask from "@ambition/components/messages/EmailTask"

	export default {
		name: "EmailDigitalSigningRequest",
		components: {
            EmailSendingOptions,
			EmailRecipients,
			EmailAttachments,
			EmailMarkupMulti,
			EmailTask,
		},
		props: {
			visible: {
				required: true,
			},
		},
		data() {
			return {
				loading: false,
				form: {},
                populateRecipients: true,
			}
		},
		computed: {
			...mapGetters({
				docDocuments: "documents/all",
				emailBuilder: "builderEmail/getEmail",
                application: "initAppData",
                templatesLoaded: "builderEmail/checkTemplatesLoaded",
			}),
			docsForSigning() {
				return this.docDocuments.filter((doc) => {
					return doc.digital_sign_available == 1
				})
			},
			disabled() {
				if (!this.emailBuilder.sendEmail && !this.emailBuilder.sendSms) return true
                if (this.emailBuilder.delaySending && !this.emailBuilder.sendAt) return true
                if (!this.templatesLoaded) return true
                if (_.size(this.emailBuilder.recipients) >= 1 && !this.loading) return false
                return true
			},
		},
		mounted() {},
		methods: {
			submit() {
				this.loading = true
				axios
					.post(
						"/api/builder-email",
						{
							application_id: this.application.id ? this.application.id : null,
                            email: this.emailBuilder
						},
						{
							headers: {
								Authorization: "Bearer " + this.$store.getters.token,
							},
						}
					)
					.then((response) => {
						this.loading = false
                        this.$emit('update:visible', false);
                        // create application task
                        if (_.get(this.emailBuilder, 'task.create', false)) {
                            this.$store.dispatch("statusIndicators/changeStatus", {
                                stage: "createTask",
                                token: this.$store.getters.token,
                                remindMe: this.$moment(this.emailBuilder.task.remindMe).format("YYYY-MM-DD"),
                                taskName: this.emailBuilder.task.name,
                                time: this.emailBuilder.task.time,
                                userId: this.emailBuilder.task.userId,
                                appId: this.application.id
                            })
                        }

                            // create recipient tasks
                        if (_.get(this.emailBuilder, 'recipients', false)) {
                            this.emailBuilder.recipients.forEach(recipient => {
                                if (_.get(recipient, 'template.task.create', false)) {
                                    this.$store.dispatch("statusIndicators/changeStatus", {
                                        stage: "createTask",
                                        token: this.$store.getters.token,
                                        remindMe: this.$moment(recipient.template.task.remindMe).format("YYYY-MM-DD"),
                                        taskName: recipient.template.task.name,
                                        time: recipient.template.task.time,
                                        userId: recipient.template.task.userId,
                                        appId: this.application.id
                                    })
                                }
                            })
                        }

					})
					.catch((error) => {
                        console.log(error)
					})
			},
			close() {
				this.form = {}
				this.$emit("update:visible", false)
				this.emailBuilder.recipients = []
			},
		},
		watch: {
            visible: {
                handler() {
                    this.$store.dispatch("builderEmail/resetEmail")
                },
                deep: true,
                immediate: true
            },
			"form.docForSigning": {
				handler(document) {
					let newSize = 0
					let email = []
                    this.emailBuilder.recipients = []
					this.emailBuilder.cc = []
					this.emailBuilder.bcc = []
					this.form.stillToSign = []

					if (document) {
						newSize += parseFloat(document.file_size || 0)
						this.form.attachmentsTotalSize = parseFloat(newSize).toFixed(2)

						document.signatures.forEach((signature) => {
							if (signature.applicant != undefined) {
								if (signature.is_traversed == 0) {
                                    email.push({
                                        type: "applicant",
                                        applicant_id: signature.applicant.id,
                                        email: signature.applicant.email,
                                        name: signature.applicant.full_name,
                                        phone: signature.applicant.phone,
                                        phoneIsMobile: signature.applicant.hasValidMobile,
                                        signed: signature.is_traversed,
                                    })
                                }

							} else {
                                let invoiceSignature;

                                if (_.get(this.application, 'invoiceInformation', false)) {
                                    invoiceSignature = this.application.invoiceInformation.find(
                                        (information) => information.id == signature.user_id
                                    )
                                }

								if (typeof invoiceSignature !== "undefined") {


									let type = "dealer"
									if (invoiceSignature.type == "contact") {
										type = "seller"
									}
                                    if (signature.is_traversed == 0) {
                                        email.push({
                                            type: type,
                                            user_id: signature.user_id,
                                            email: signature.user.email,
                                            name: signature.user.full_name,
                                            phone: signature.user.phone,
                                            phoneIsMobile: signature.user.hasValidMobile,
                                            signed: signature.is_traversed,
                                        })
                                    }


								} else {
                                    if (signature.is_traversed == 0) {
                                        email.push({
                                            type: "other",
                                            user_id: signature.user_id,
                                            email: signature.user.email,
                                            name: signature.user.full_name,
                                            phone: signature.user.phone,
                                            phoneIsMobile: signature.user.hasValidMobile,
                                            signed: signature.is_traversed,
                                        })

                                    }
								}
							}
						})

                        // filter out any duplicate values
                        email = _.uniqBy(email, function (e) {
                            return e.email;
                        });

						this.form.selectedEmails = !_.isEmpty(email) ? email : []
                        this.populateRecipients = !_.isEmpty(email) ? true : false
					}
				},
				deep: true,
			},
		},
	}
</script>

<style lang="scss" scoped>
</style>
